export default {
    general: {
        back: "Retour",
        validate: "Valider",
        confirm: "Confirmer",
        delete: "Supprimer",
        save: "Sauver",
        loading: "Chargement",
        share: "Partager",
        download: "Télécharger",
        retry: "Réessayer",
        html5NotSupported: "Votre navigateur ne suporte pas les vidéos HTML5.",
        permissionError: "Permission manquante",
        motionPermissionRefused:
            "La vue AR nécessite l'accès aux mouvements du téléphone. Veuillez redémarrer votre navigateur et accorder l'accès à la demande de détecteur de mouvement.",
        GCU: "Conditions générales d'utilisation",
        serverError: "Erreur serveur",
        camera: "Caméra",
        landscapeMessage: "Veuillez tenir votre appareil en portrait",
        rgpdUrl: "https://ar-go.co/fr/stqr-politique-de-confidentialite/",
        RGPDLinkText: "Politique de confidentialité",
        or: "ou",
        cancel: "Annuler"
    },
    rgpd: {
        popinTitle: "Avant d'aller plus loin, nous avons besoin de ton accord :",
        termsAndConditionsText:
            "J’accepte les <a target='blank' href='https://ar-go.co/fr/stqr-conditions-generales-dutilisation/?fbclid=IwAR06X4GKvo1T987KEVciGOCttCWNvepzMKAJ1uu54JHVwZNG6DqmfbAhc_k'>conditions générales d’utilisation</a> et la <a target='blank' href='https://ar-go.co/fr/stqr-politique-de-confidentialite/'>politique de confidentialité</a>.",
        shareEmailText:
            "J’accepte de transmettre à l’émetteur de ce QR code l’email associé à mon compte, pour qu’il puisse me contacter dans le cadre de cette expérience seulement.",
        acceptAll: "Tout accepter",
        rejectAll: "Tout refuser",
        submit: "Valider",
        error: {
            termsAndConditionsCheckboxRequired:
                "Vous devez accepter les conditions générales d’utilisation et la politique de confidentialité pour poursuivre l'expérience."
        }
    },
    home: {
        record: "Enregistrer ma vidéo",
        edit: "Modifier",
        changeBrowser: "Navigateur non supporté",
        changeBrowserDetail:
            "Désolé, l'application n'est pas compatible avec votre navigateur. Merci d'utiliser Chrome ou Firefox sur Android et Safari sur iOS.",
        copyUrl: "Copier l'URL",
        adBannerTitle: "Ne manquez pas l'offre du Mois !",
        adBannerText: "stqr vous intéresse ? Contactez-nous pour en savoir plus",
        adBannerUrl: "https://ar-go.co/fr/stqr/#stqr-contact",
        leftCTATitle: "Contact",
        rightCTATitle: "Liens",
        processingVideo: "Veuillez patienter, votre vidéo est en cours de traitement..."
    },
    ar: {
        firstPopin: "Placez le repère sur une surface plane face à vous",
        secondPopin: "Cliquez sur le repère pour lancer l'animation"
    },
    optionalSignUp: {
        intro:
            "Tu pourras éditer à tout moment les vidéos liées à tes QR Codes sur ton compte <a href='https://admin.stqr.io' target='_blank'>stqr.io</a>.",
        createAccount: "Créer un compte personnel",
        noSignUp: "Continuer sans inscription",
        warning: "Attention !",
        warningMessage:
            "Tu ne pourras pas revenir modifier ni supprimer tes vidéos personnelles une fois celles-ci déposées.",
        recommended: "recommandé"
    },
    signInUp: {
        introSignUp:
            "Inscris-toi pour ajouter ton message vidéo personnalisé. Tu pourras éditer à tout moment les vidéos liées à tes QR Codes sur ton compte <a href='https://admin.stqr.io' target='_blank'>stqr.io</a>.",
        signIn: "S'identifier",
        emailAddress: "Adresse e-mail",
        password: "Mot de passe",
        passwordConfirm: "Confirmation du mot de passe",
        createAccount: "Créer un compte",
        name: "Nom",
        alreadyHaveAccount: "J'ai déjà un compte",
        googleSignIn: "Se connecter avec Google",
        forgetPasswordTitle: "Mot de passe oublié",
        forgetPasswordTutorial:
            "Merci d'entrer votre adresse email, nous vous enverrons un mail avec un nouveau mot de passe.",
        forgetPasswordSuccess: "Email envoyé",
        onSignUpPopinTitle: "Merci d’avoir créé votre compte stqr",
        onSignUpPopinText:
            "Un email avec le lien d’accès à votre compte vous a été envoyé. Vous pouvez éditer vos videos à tout moment en vous connectant à votre compte personnel stqr.",
        remindsMe:
            "J’autorise le dépôt d’un cookie local pour ne pas avoir à ressaisir mes identifiants de compte à chaque utilisation du service",
        notQrOwner: "Ce compte n'est pas propriétaire du message",
        ATHERR00_EMAIL: "Format email incorrect",
        ATHERR00_NAME: "Format nom incorrect",
        ATHERR00_PWD: "Mot de passe incorrect",
        ATHERR00_INC: "Données incorrectes",
        ATHERR01: "Données incorrectes",
        ATHERR02: "Compte déjà existant",
        ATHERR03: "Utilisateur non trouvé",
        ATHERR04: "Ce compte Google n'a pas les autorisations nécessaires",
        INTERR0: "Une erreur est survenue",
        notInDemo: "Fonctionnalité indisponible en mode démonstration",
        pwdLength: "Le mot de passe doit comporter 8 à 12 caractères",
        pwdNumberRequired: "Inclure un chiffre",
        pwdUpperRequired: "Inclure des caractères majuscules et minuscules",
        pwdNoSpace: "Ne pas inclure d'espaces",
        pwdNoMatch: "Les mots de passe ne correspondent pas",
        "Network Error": "Erreur de connexion au serveur",
        unknownError: "Une erreur est survenue"
    },
    record: {
        unsupported: "Format non supporté",
        available: "Formats : mov, mp4, avi, mpg",
        videoTooBigTitle: "Vidéo trop grande",
        videoTooBigText:
            "Votre vidéo ne doit pas dépasser {maxSize}Mo ({currentSize}Mo actuellement)",
        videoTooLongTitle: "Vidéo trop longue",
        videoTooLongText: "Votre vidéo ne doit pas dépasser {maxDuration} secondes",
        videoPickingText:
            "Cliquez sur le bouton pour créer ou charger une vidéo.<br/>Pas plus de { maxDuration } secondes pour une expérience optimale."
    },
    upload: {
        uploading: "Transfert de la vidéo",
        experienceCreating: "Création de votre expérience",
        uploadError: "Une erreur est survenue lors de l'envoi de la vidéo."
    },
    success: {
        doneMultiVideo: "Votre vidéo a bien été envoyée.",
        done: "C'est fait !",
        seeMyVideoAR: "Voir ma vidéo en RA",
        seeMyVideoHome: "Voir ma vidéo en plein écran"
    },
    share: {
        openTitle: "Découvrez stqr, le message video qui se colle partout",
        openText: "Démo",
        burnedTitle: "Vous avez un message vidéo"
    },
    desktop: {
        title: "Vous avez un message !",
        tutorialNoMessage:
            "<b>Scannez ce QR code</b> avec la caméra de votre téléphone pour poster un message vidéo.",
        tutorial:
            "<b>Scannez ce QR code</b> avec la caméra de votre téléphone pour voir le message vidéo.",
        tutorial2: "Ou ouvrez ce lien depuis votre smartphone ou tablette"
    },
    errors: {
        title: "Oups",
        qrcodeNotFoundTitle: "QRCode pas trouvé",
        qrcodeNotFoundText: "Impossible trouver le QR code... désolé.",
        serverErrorTitle: "Erreur serveur",
        serverErrorText: "Problème de connexion à notre serveur QRCode",
        networkErrorTitle: "Erreur réseau",
        networkErrorText:
            "Problème de connexion réseau. Certaines fonctionnalités peuvent ne pas être disponibles",
        timeout: "Temps mort",
        noGyro:
            "Votre appareil semble être incompatible avec l'affichage AR. Impossible d'accéder à l'orientation. Veuillez renouveler l'expérience sur un autre appareil.",
        videoConnectionProblems: "Vidéo ne peut pas être chargée"
    },
    report: {
        report: "Signaler",
        popinTitle: "Signaler",
        selectReason: "Veuillez sélectionner une raison",
        step2Title: "Votre signalement est anonyme",
        step2Subtitle:
            "Laissez-nous vos coordonnées si vous souhaitez être recontacté à propos de ce signalement.",
        step3Title: "Merci",
        step3Subtitle: "Votre signalement a été pris en compte",
        step3Text: "Nous procéderons à son évaluation dans les plus brefs délais",
        requiredField: "Champ obligatoire",
        keepMeInformed: "Je veux être informé",
        lastName: "Nom",
        firstName: "Prénom",
        email: "Email",
        message: "Message",
        close: "Fermer",
        bannedVideoMessage: "Cette vidéo a été supprimée suite à un signalement",
        reasons: {
            HATE: "Discours ou symboles haineux",
            NUDITY_SEX: "Nudité ou activité sexuelle",
            ANIMAL_CRUELTY: "Cruauté envers les animaux",
            SUICIDE_SELF_INJURY: "Suicide ou auto-mutilation",
            BULLYING: "Intimidation ou harcèlement",
            FAKE_NEWS: "Information mensongère",
            VIOLENCE: "Violence ou personnes dangereuses",
            SCAM: "Escroquerie ou fraude",
            SALE_ILLEGAL: "Vente de marchandises illégales, règlementées",
            INTELLECTUAL_VIOLATION: "Violation de propriété intellectuelle",
            CHILDREN_SAFETY: "Sécurité des mineurs"
        },
        errors: {
            invalidEmail: "L'adresse e-mail est incorrecte",
            emailFieldRequiredField: "Le champ e-mail est obligatoire",
            unknownError: "Une erreur est survenue, veuillez réessayer",
            EEXISTS: "Cette vidéo a déjà été signalée"
        }
    },
    reply: {
        title: "Saisissez votre réponse. Vous pouvez indiquer vos nom et prénom dans votre message",
        btnReply: "Je réponds",
        replySent: "Votre réponse envoyée avec succès !",
        firstName: "Prénom",
        lastName: "Nom",
        textAreaPlaceholder: "Entrer le texte",
        sending: "Envoi..."
    },
    inactive: {
        landingPageText: "Cette expérience a été désactivée par son propriétaire"
    },
    personalDataForm: {
        title: "Données personnelles",
        firstNameLabel: "Prénom",
        lastNameLabel: "Nom",
        emailLabel: "E-mail",
        phoneLabel: "Téléphone",
        errors: {
            fieldRequired: "Ce champ est requis",
            fieldValueIncorrect: "Valeur incorrecte",
            videoAgreement:
                "Vous devez accorder l'autorisation d'utiliser votre vidéo à des fins promotionnelles afin de poursuivre l'expérience"
        }
    }
};
